import { useUserStore, type UserInfo } from '@/stores/user'
import { setConfig } from '@ideaflow/ui/utils/config'
import { getEnvMode } from '@/utils/env'
import { user } from '@ideaflow/ui/classes/user'
import DreamaLoginLogo from '@/components/dreama-login-logo'
import { loginWithBlankClose } from '@/utils/login'

/**
 * 初始化用户信息。
 * 每次调用时先用 cookie 与 store 同步，再按需唤起登录，并补齐权限相关数据。
 */
const env = getEnvMode()
setConfig('API_ENV', env)

type InitUserResult = {
  userStore: ReturnType<typeof useUserStore>
}

export function syncUserFromCookie(userStore = useUserStore()) {
  const cookieUser = user.get()

  if (cookieUser === null) {
    userStore.resetUserInfo()
    return false
  }

  userStore.setUserInfo(cookieUser as unknown as UserInfo)
  return userStore.isLoggedIn()
}

export async function useInitUser(): Promise<InitUserResult> {
  const userStore = useUserStore()
  syncUserFromCookie(userStore)

  if (!userStore.isLoggedIn() || !userStore.userInfo) {
    const userInfo = await loginWithBlankClose({
      logo: DreamaLoginLogo,
    })

    if (userInfo) {
      userStore.setUserInfo(userInfo as unknown as UserInfo)
    }
  }

  await Promise.all([userStore.fetchMediaWhiteUids(), userStore.fetchIdentityByUserIds()])

  return {
    userStore,
  }
}
